module.exports = __webpack_public_path__ + "img/34.931fc280.png";